import { DictionaryObject } from '@cawita/core-front';
import { ApiData } from '@cawita/core-front/api';
import { CwtModel } from '@shared/modules/crud';
import { Document } from './document.model';
import { Partner } from './partner.model';

@CwtModel({ name: 'tip', path: '/goodmap' })
export class Tip extends ApiData {
    partners?: Partner[];
    name?: DictionaryObject;
    subtitle?: DictionaryObject;
    description?: DictionaryObject;
    isActive?: boolean;
    favorite?: boolean;
    nbClics?: number;
    url?: string;
    urlName?: DictionaryObject;
    picture?: Document;
    pictures?: Document[];

    fieldDictionary() {
        return {
            partners: [Partner]
        };
    }
}
